import { Role } from '../../../../shared/enums/role.enum';
import { SecondarySideMenuI } from '../../../../shared/interfaces/secondary-side-menu.interface';

export const SIDE_MENU_ITEMS: SecondarySideMenuI[] = [
  {
    translationPath: 'sideMenu.courseClos',
    activeIcon: 'svgs/side-menu/active-course.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-course.svg',
    route: () => 'courses-clos',
    alt: 'courses clos',
    roles: [Role.SUPER_ADMIN, Role.ADMIN],
  },
  {
    translationPath: 'sideMenu.courseSectionsProgress',
    activeIcon: 'svgs/side-menu/active-student.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-student.svg',
    route: () => 'course-sections-progress',
    alt: 'course sections progress',
    roles: [Role.SUPER_ADMIN, Role.ADMIN],
  },
];
